export default __webpack_public_path__ + "static/brand-64946477a38f744ce62cb07a31c0d7a8.jpg";